export default __webpack_public_path__ + "static/media/Vin_Imei_map.80153025.xlsx";